import React from 'react';
import { createRoot } from 'react-dom/client'; // Importa createRoot
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// 1. Crea el contenedor raíz
const container = document.getElementById('root');
const root = createRoot(container); 

// 2. Renderiza la app
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);